<template>
   <v-dialog v-model="isVisible" persistent max-width="1000">
        <v-toolbar dark color="primary" >
            <v-toolbar-title class="white--text" >Save filter</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="close">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card >
            <v-card-text v-if="filter">
               <v-form ref="form" v-model="isValid">

                  <v-text-field
                      v-model="filter.name"
                      label="Name english"></v-text-field>
                  <v-select
                    :items="users"
                    item-text="username"
                    :rules="rules.userRules"
                    item-value="_id"
                    v-model="filter.user"
                    :menu-props="{ maxHeight: '400' }"
                    label="Select"
                    hint="Pick Users for this filter"
                    multiple
                    persistent-hint></v-select>
               </v-form>
            </v-card-text>
             <v-card-actions>
        
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    flat="flat"
                    @click="close">
                    Cancel
                </v-btn>
                <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="save()" :disabled="!isValid">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import ArticleList from './ArticleList'
import AddressBox from './AddressBox'
import PaymentInfoBox from './PaymentInfoBox'

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    filter: {
      type: Object,
     //  required: true
    }
  },
  components: {
    ArticleList,
    AddressBox,
    PaymentInfoBox
  },
  data() {
    return {
      isValid: false,
      rules: {
        userRules: [
            v => v.length > 0 || 'User is required'
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'users'
    ])
  },
  methods: {
    close () {
      this.$emit('close')
    },
    save () {
      if(this.$refs.form.validate()) {
        this.$emit('save', this.filter)
      }
    },

  },
  created () {
		//  const pivotGrid = this.$refs.grid.instance
		this.$store.dispatch('getUsers')
	}
}
</script>
